module.exports = __webpack_public_path__ + "static/media/desktop-icons-buttons-page-navigation-left-arrow-disabled.63cef0bb.svg";